"use strict";

define('components/tasks',['components/ajax', 'components/form', 'components/dom_setup', 'components/filter_bar'], function(ajax, form, domSetup, filterBarComponent) {

    var tasks = {

        init: function(tasksModule) {
            var self = this;


            // Add new event handlers
            tasksModule.find('#sort-by-date').click(function(e) {
                _sortByDateToggle('date');
            });
            tasksModule.find('#reverse-sort-by-date').click(function(e) {
                _sortByDateToggle('reverse-date');
            });
            tasksModule.find('#undo-sort-by-date').click(function(e) {
                _sortByDateToggle('');
            });

            // Initialize pagination links for XHR
            self.initPaginationLinks(tasksModule);

            // Initialize the filterbar to manage state on filter and pagination
            filterBarComponent.init(tasksModule);


            function _sortByDateToggle(by) {
                var baseUrl = [window.location.protocol, '//', window.location.host, window.location.pathname].join('');
                var queryString = window.location.search;

                var regex = /sort-by=(reverse-)?date/
                var newSort = by === '' ? '' : 'sort-by='.concat(by)
                if (regex.test(queryString)) {
                    queryString = queryString.replace(regex, newSort);
                } else {
                    queryString = queryString.concat('&'.concat(newSort));
                }
                // if we've got a leading ampersand as a result of sorting and then filtering, replace it with a ?
                if (queryString.startsWith('&')) {
                    queryString = queryString.replace('&', '?')
                }

                $('.loading-overlay').removeClass('hidden');
                ajax(baseUrl.concat(queryString), {
                    onSuccess: function(result) {
                        $('.task-list-big').replaceWith(result.body);
                        $('.loading-overlay').addClass('hidden');
                        window.history.pushState({}, document.title, baseUrl.concat(queryString));

                        // Scroll to the top of the page
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });

                        self.init($('#tasks-module'));
                    },
                    onFailure: function(result) {
                        $('.loading-overlay').addClass('hidden');

                        self.init($('#tasks-module'));
                    }
                })
            }

            tasksModule.find('.add-link').off('click').click(function(e) {
                var addLink = $(this);
                var addUrl = addLink.data('add-url') || addLink.attr('href');
                // When a user clicks 'View all' from the dashbaord we do not want the logic below to run
                // as we simply want to redirect to the global tasks page.
                if (addUrl !== '/tasks') {
                    e.preventDefault();
                    addLink.addClass('disabled');
                    addLink.prop('disabled', true);

                    $.ajax({
                        url: addUrl,
                        type: 'GET',
                        processData: false,
                        success: function(result) {
                            var moduleBody = tasksModule.find('.module-body');
                            var firstRow = $(moduleBody.find('.task-row:not(.task-table-heading)')[0])
                            if (firstRow.length == 0) {
                                firstRow = $(moduleBody.find('p')[0]);
                            }
                            firstRow.before(result);
                            self.initDetailsModule(firstRow.prev(), addLink);
                        },
                        error: function(result) {
                            addLink.removeClass('disabled');
                            addLink.prop('disabled', false);
                        },
                    });
                }
            });

            tasksModule.find('.add-task-dashboard').off('click').click(function(e) {
                e.preventDefault();
                var addLink = $(this);
                addLink.addClass('disabled');
                addLink.prop('disabled', true);
                var addUrl = addLink.data('add-url') || addLink.attr('href');

                $.ajax({
                    url: addUrl,
                    type: 'GET',
                    processData: false,
                    success: function(result) {
                        var tasksModuleFooter = addLink.parent()
                        tasksModuleFooter.before(result);
                        self.initDetailsModule(tasksModuleFooter.prev(), addLink);
                    },
                    error: function(result) {
                        addLink.removeClass('disabled');
                        addLink.prop('disabled', false);
                    },
                });
            });

            // Handler for all row-level click events.  Handle the following transitions:
            // 1. summary view -> detail view
            // 2. detail view -> edit view
            tasksModule.click(function(e) {
                // Ignore clicks handled elsewhere
                var clickTarget = $(e.target);
                if (clickTarget.is('a') || clickTarget.is('.add-link') || clickTarget.parent().is('button.close') ||
                    clickTarget.closest('.buttonbar').length > 0) {
                    return true;
                }

                var row = clickTarget.closest('.task-row:not(.task-table-heading)');
                if (row.length == 0) {
                    return true;
                }

                // Handle clicks on the close-task action
                if (clickTarget.is('.task-close')) {
                    self.handleTaskCloseClick(clickTarget, row);
                    return;
                }

                if (row.hasClass('task-details')) {
                    return self.handleDetailClick(row, e);
                } else {
                    return self.handleSummaryClick(row);
                }
            });
        },

        handleTaskCloseClick: function(closeButton, row) {
            var url = closeButton.data('url');
            ajax(url, {
                onSuccess: function(result) {
                    if (closeButton.hasClass('glyphicon-unchecked')) {
                        closeButton.removeClass('glyphicon-unchecked').addClass('glyphicon-check text-success');
                        row.addClass('task-closed');
                    } else {
                        closeButton.removeClass('glyphicon-check text-success').addClass('glyphicon-unchecked');
                        row.removeClass('task-closed');
                    }
                },
                onFailure: function(result) {
                    // debugger;
                }
            });
        },

        handleTaskDeleteClick: function(deleteButton) {
            var url = deleteButton.data('url');
            ajax(url, {
                onSuccess: function(result) {
                    var row = deleteButton.closest('.task-row');
                    var list = row.parent();
                    row.hide('slow', function() {
                        if (row.siblings().length == 0) {
                            list.html('<p class="no-tasks-msg"><em>There are no more open tasks</em></p>');
                        }
                        row.remove();
                    });
                },
                onFailure: function(result) {
                    // debugger;
                }
            });
        },

        handleSummaryClick: function(row) {
            var rowId = row.attr('id')
            var self = this;
            $.ajax({
                url: row.data('url'),
                type: 'GET',
                processData: false,
                success: function(result) {
                    row.replaceWith(result);
                    self.initDetailsModule($('#' + rowId + '-details'));
                },
            });
        },

        handleDetailClick: function(row, e) {
            var self = this;

            var clickTarget = $(e.target);

            // Handle clicks on the close-task action
            if (clickTarget.is('.task-delete')) {
                self.handleTaskDeleteClick(clickTarget);
                return false;
            }

            if (clickTarget.closest('.task-editable').length) {
                row.removeClass('view').addClass('edit');
                row.find('.task-view').addClass('hidden');
                row.find('.task-edit').removeClass('hidden');

                var focusTarget = clickTarget.closest('.task-editable').data('focus-target');
                if (focusTarget) {
                    row.find(focusTarget).focus();
                }
                return false;
            }
            else if (clickTarget.closest('.task-view').length) {
                self.restoreSummaryRow(clickTarget.closest('.task-row'));
                return false;
            }
            return true;
        },

        restoreSummaryRow: function(row) {
            var moduleContext = row.closest('.module-body').data('module-context') || '';
            $.ajax({
                url: row.data('view-url') + moduleContext,
                type: 'GET',
                processData: false,
                success: function(result) {
                    row.replaceWith(result);
                },
            });
        },

        initDetailsModule: function(detailsModule, addLink) {
            domSetup.init(detailsModule);

            var self = this;
            detailsModule.on('click', 'button', function(e) {
                e.preventDefault();
                var button = $(this);
                var buttonName = button.attr('name');

                if (buttonName == 'close' || (buttonName == 'cancel' && !addLink)) {
                    self.restoreSummaryRow(button.closest('.task-row'));
                    return;
                }
                if (buttonName == 'cancel' && addLink) {
                    detailsModule.remove()
                    addLink.removeClass('disabled');
                    addLink.prop('disabled', false);
                    return;
                }
                if (buttonName == 'save') {
                    var moduleContext = detailsModule.closest('.module-body').data('module-context') || '';
                    var addForm = detailsModule.find('form');
                    var formData = form.serialize(addForm);
                    if (addLink) {
                        var addUrl = addLink.data('add-url') || addLink.attr('href');
                        self.submitAddForm(detailsModule, formData, addUrl, addLink, button);
                    } else {
                        var row = button.closest('.task-row');
                        var saveUrl = row.data('save-url');
                        self.submitEditForm(row, formData, saveUrl + moduleContext);
                    }
                    return;
                }
            });
        },

        submitAddForm: function(detailsModule, formData, url, addLink, submitButton) {
            var self = this;
            submitButton.addClass('disabled');
            submitButton.prop('disabled', true);

            // append any filters to the add url so that the result-count module can be updated appropriately.
            var taskListFilters = window.location.search.substring(1);
            if (taskListFilters) {
                url = url + '&' + taskListFilters;
            }
            ajax(url, {
                formData: formData,
                onSuccess: function(result) {
                    // Remove the 'no tasks' message line if present on successful add.
                    detailsModule.closest('.module').find('.no-tasks-msg').remove();

                    // Update the details module with the row-view of the new task
                    detailsModule.replaceWith(result.body)

                    // Re-enable the add link
                    if (addLink) {
                        addLink.removeClass('disabled');
                        addLink.prop('disabled', false);
                    }
                },
                onFailure: function(result) {
                    detailsModule.replaceWith(result.body)
                    self.initDetailsModule($('#task-0-details'), addLink);
                    submitButton.removeClass('disabled');
                    submitButton.prop('disabled', false);
                },
                onError: function(result) {
                    submitButton.removeClass('disabled');
                    submitButton.prop('disabled', false);
                }
            });
        },

        submitEditForm: function(row, formData, url) {
            var self = this;
            ajax(url, {
                formData: formData,
                onSuccess: function(result) {
                    row.replaceWith(result.body);
                },
                onFailure: function(result) {
                    var rowId = row.attr('id')
                    row.replaceWith(result.body);
                    self.initDetailsModule($('#' + rowId));
                },
            });
        },

        initPaginationLinks: function(tasksModule) {
            var self = this;

            // First, remove any existing pagination click handlers to prevent duplicates
            tasksModule.off('click', '#task-pagination a');

            // Handle pagination link clicks using event delegation
            tasksModule.on('click', '#task-pagination a', function(e) {
                e.preventDefault();
                var pageUrl = $(this).attr('href');

                // Show loading overlay
                $('.loading-overlay').removeClass('hidden');

                // Clean up the URL to ensure we don't accumulate multiple page parameters
                // Parse the URL to get its components
                var urlObj = new URL(pageUrl, window.location.origin);
                var params = new URLSearchParams(urlObj.search);

                // Get the page number from the link
                var match = $(this).attr('href').match(/[?&]page=(\d+)/);
                var pageNum = match ? match[1] : null;
                if (!pageNum) {
                    return;
                }
                // Remove any existing page parameter and add the new one
                params.delete('page');
                params.append('page', pageNum);

                // Reconstruct the URL with the updated parameters
                urlObj.search = params.toString();
                var cleanPageUrl = urlObj.pathname + urlObj.search;

                // Make AJAX request to get the new page
                // We need to use POST because the index_xhr method expects a POST request
                // Use the custom ajax component that automatically includes the CSRF token
                ajax(cleanPageUrl, {
                    method: 'POST',
                    onSuccess: function(result) {
                        // Update the task list
                        // The task list is inside a div with id 'task-list'
                        // The result.body contains the rendered task_list panel
                        $('#task-list').html(result.body);

                        // Update the pagination controls if they exist in the response
                        if (result.updates && result.updates['#task-pagination']) {
                            $('#task-pagination').html(result.updates['#task-pagination']);
                        }

                        // Update the result counts if they exist in the response
                        if (result.updates && result.updates['#result-counts']) {
                            $('#result-counts').html(result.updates['#result-counts']);
                        }

                        // Hide loading overlay
                        $('.loading-overlay').addClass('hidden');

                        // Update browser URL without reloading the page
                        window.history.pushState({}, document.title, cleanPageUrl);

                        // Scroll to the top of the page
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });

                        // Only re-initialize the pagination links
                        // This prevents adding multiple event handlers
                        self.initPaginationLinks(tasksModule);
                    },
                    onFailure: function(result) {
                        // Hide loading overlay
                        $('.loading-overlay').addClass('hidden');

                        // Only re-initialize the pagination links
                        // This prevents adding multiple event handlers
                        self.initPaginationLinks(tasksModule);
                    }
                });
            });
        },

    };

    return tasks;
});

